import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement newsletter signup
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-sm font-semibold text-indigo-400 tracking-wider uppercase">Navigation</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <Link to="/" className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200">
                  Projects
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-indigo-400 tracking-wider uppercase">Connect</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <a
                  href="https://linkedin.com/in/ikunle"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/ikunle"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200"
                >
                  GitHub
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-indigo-400 tracking-wider uppercase">Resources</h3>
            <ul className="mt-4 space-y-4">
              <li>
                <a
                  href="https://docs.google.com/document/d/18sH0AV_s0vR_kbFGhWLCkgua6xcMwqCM9qU1UmjZbN4/edit"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200"
                >
                  $1M Micro SaaS Guide
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-base text-gray-300 hover:text-indigo-400 transition-colors duration-200">
                  Product Management Insights
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-indigo-400 tracking-wider uppercase">Newsletter</h3>
            <p className="mt-4 text-base text-gray-300">
              Get updates about new products and insights.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="mt-4">
              <div className="flex">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="min-w-0 flex-1 rounded-l-lg border border-gray-700 bg-gray-800/50 px-3 py-2 text-base text-white placeholder-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 backdrop-blur-sm"
                  placeholder="Enter your email"
                  required
                />
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  type="submit"
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-r-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Subscribe
                </motion.button>
              </div>
            </form>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-800 pt-8">
          <p className="text-base text-gray-400 text-center">
            &copy; {new Date().getFullYear()} SS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 